import type { IconName } from './components/ui';

export interface NavItem {
  to: string;
  label: string;
  icon: IconName;
  /** Extra search terms. */
  keywords: string;
}

export const NAV: Array<{ section: string; links: NavItem[] }> = [
  {
    section: 'Mulai',
    links: [
      { to: '/dashboard', label: 'Beranda', icon: 'home', keywords: 'dashboard ringkasan saldo pemakaian' },
      { to: '/playground', label: 'Playground', icon: 'terminal', keywords: 'coba model chat uji prompt gambar video' },
      { to: '/models', label: 'Model', icon: 'grid', keywords: 'katalog daftar model harga konteks' },
      { to: '/docs', label: 'Dokumentasi', icon: 'book', keywords: 'docs panduan api referensi' },
    ],
  },
  {
    section: 'Kelola',
    links: [
      { to: '/api-keys', label: 'API Key', icon: 'key', keywords: 'kunci api token buat key cabut akses model' },
      { to: '/projects', label: 'Proyek', icon: 'folder', keywords: 'project anggaran budget model cadangan fallback' },
      { to: '/usage', label: 'Pemakaian', icon: 'bars', keywords: 'usage statistik log request biaya token grafik' },
    ],
  },
  {
    section: 'Tagihan',
    links: [
      { to: '/wallet', label: 'Saldo & Top Up', icon: 'wallet', keywords: 'isi saldo top up qris bayar bonus wallet' },
      { to: '/transactions', label: 'Transaksi', icon: 'swap', keywords: 'ledger riwayat mutasi bonus potongan' },
      { to: '/settings', label: 'Pengaturan', icon: 'gear', keywords: 'akun organisasi tema tampilan keluar sesi' },
    ],
  },
];
